const fetchRetry = /* #__PURE__*/require('fetch-retry')(global.fetch);
const handleFetch = async function (path) {
  let {
    query,
    circuitBreaker,
    retries = null,
    retryOn = null,
    retryDelay = null,
    ...options
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let onError = arguments.length > 2 ? arguments[2] : undefined;
  const url = new URL(path);
  if (query) {
    url.search = new URLSearchParams(query).toString();
  }
  const enableRetry = retries || retryOn || retryDelay;
  let passedOptions = options;
  try {
    let response;
    if (enableRetry) {
      passedOptions = {
        ...options,
        ...(retries && {
          retries
        }),
        ...(retryOn && {
          retryOn
        }),
        ...(retryDelay && {
          retryDelay
        })
      };
      response = await fetchRetry(url.href, passedOptions);
    } else {
      response = await fetch(url.href, passedOptions);
    }
    return response;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    if (onError) {
      onError(error);
    } else if (options?.circuitBreaker) {
      throw error; // throws error to circuitbreaker
    }
    return {};
  }
};
async function fetchJSON(url, options, onError) {
  const fetchOptions = {
    // credentials: 'include',
    method: 'GET',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers
    }
  };
  if (['POST', 'PATCH', 'PUT'].includes(fetchOptions.method)) {
    // default fetchOptions.body to empty object
    // if it does not exist
    if (!fetchOptions.body) {
      fetchOptions.body = {};
    }
    const {
      query = {},
      search = {},
      data = {}
    } = fetchOptions;

    // merge all request data options to body for posts
    fetchOptions.body = JSON.stringify({
      ...data,
      ...query,
      ...search,
      ...fetchOptions.body
    });
  }
  const response = await handleFetch(url, fetchOptions, onError);
  if (fetchOptions.method === 'PUT') {
    return {
      statusCode: response.status
    };
  }
  try {
    if (response) {
      const json = await response.json();
      return json;
    }
  } catch (e) {
    return {};
  }
  return {};
}
export { fetchJSON as default };
